// -------------------------------------------
// --       Data Formatting Utility         --
// -------------------------------------------

export default class StringFormat {
    // Removes all digits.
    removeAllDigits(str) {
        if (this.isNullOrUndefined(str)) return null;
        return str.replace(/[0-9]/g, "");
    }

    // Removes any non-digit.
    removeAllNonDigits(str) {
        if (this.isNullOrUndefined(str)) return null;
        return str.replace(/\D/g, "");
    }

    // Removes whitespace.
    removeWhitespace(str) {
        if (this.isNullOrUndefined(str)) return null;
        return str.replace(/\s/g, "");
    }

    // Returns true if null or undefined.
    isNullOrUndefined(val) {
        if (val === undefined || val === null) return true;
        return false;
    }

    // Returns the selected value, or null.
    getSafeValue(val) {
        if (this.isNullOrUndefined(val)) return null;
        if (val.length < 1) return null;
        return val;
    }

    // Return base postal code.
    getPostalCodeBase(val) {
        if (this.isNullOrUndefined(val)) return null;
        const parts = val.split("-");
        return parts[0];
    }

    /**
     * Sanitizes address line input by removing unwanted characters and trimming whitespace.
     * @param {string} input - The input string to sanitize
     * @returns {string|null} - The sanitized string or null if input is not a string
     */
    sanitizeAddressLine(input) {
        if (typeof input !== "string" || input.trim().length === 0) return null;

        // Replace tabs, newlines, carriage returns
        input = input.replace(/[\t\n\r]/g, "");

        // Replace multiple spaces with a single space
        input = input.replace(/\s{2,}/g, " ");

        // Remove specified special characters
        input = input.replace(/[*&,;]/g, "");

        // Trim leading and trailing spaces
        input = input.trim();

        return input.length === 0 ? null : input;
    }
}